import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "randomIndex",
    standalone: false
})
export class ArrayRandomIndexPipe  implements PipeTransform {
  transform(length: number): number {
    return Math.floor(Math.random() * Math.floor(length));
  }
}